// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const RolescreenSingle = () => {
//   // Extracting rolescreenId using regular expressions
//   const location = useLocation();
//   // const rolescreenId = location.pathname.match(/\/rscreen\/(\d+)/);
//   const rolescreenId = location.pathname.match(/\/role-screen\/(\d+)/)?.[1];

//   const [rscreen, setRolescreen] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchRolescreen = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/rscreen/${rolescreenId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch User');
//       // }
//       const data = await response.json();
//       setRolescreen(data);
//       localStorage.setItem("UserData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (rolescreenId) {
//       fetchRolescreen();
//     }
//   }, [rolescreenId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Role Screen Information</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{rscreen?.data.name}</h1>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Id: </span>
//                     <span className="itemValue">{rscreen?.data.id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{rscreen?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Screen Name: </span>
//                     <span className="itemValue">{rscreen?.data.name}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{rscreen?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default RolescreenSingle;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const RolescreenSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rolescreenId = location.pathname.match(/\/role-screen\/(\d+)/)?.[1];
  const [rscreen, setRolescreen] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchRolescreen = async () => {
    try {
      const response = await fetch(`${serverUrl}/rscreen/${rolescreenId}`);
      const data = await response.json();
      setRolescreen(data);
      localStorage.setItem("UserData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (rolescreenId) {
      fetchRolescreen();
    }
  }, [rolescreenId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">
                Role Screen Information
              </h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Role Screen Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Screen Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Screen Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {rscreen?.data.name}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolescreenSingle;
